// extracted by mini-css-extract-plugin
var _1 = "NewsboardPostProfileHeaderInfoItems-moduleeditableContentWrapper__Hkdtb";
export { _1 as "editableContentWrapper" }
